// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 354) return "354~vfaa576e7ca65e5a31605.js";
	if (chunkId === 418) return "418~v4b7f3e7fa7e853af4c56.js";
	if (chunkId === 661) return "661~va58458b4a4db42a75d3c.js";
	// return url for filenames based on template
	return undefined;
};